import { matchPath } from 'react-router';

export const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const anyTrue = (obj = {}) =>
  Object.values(obj).some((value) => !!value);

export const allTrue = (obj = {}) =>
  Object.values(obj).every((value) => !!value);

export const stringToBool = (str = '') => {
  if (str.toLowerCase() === 'true') {
    return true;
  }

  if (str.toLowerCase() === 'false') {
    return false;
  }

  return null;
};

export const range = (start, end, step = 1) =>
  Array.from(new Array(end), (x, i) => i * step + start);

export const checkMatchPath = (pathToCheck, targetPath) => {
  const match = matchPath(pathToCheck, {
    path: targetPath,
    exact: true,
    strict: false
  });

  return !!match;
};

/* istanbul ignore next -- @preserve */
export const loadScript = async (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const tag = document.createElement('script');

    tag.type = 'text/javascript';
    tag.onload = () => resolve();
    tag.onerror = () => reject(new Error(`Failed to load script: ${url}`));

    tag.src = url;
    document.body.appendChild(tag);
  });
};

export const maskPartialData = (string) => {
  return string?.replace(/.(?=.{4})/g, '*');
};

export const countErrorCodeOccurrences = (errors, code) =>
  errors.reduce((count, error) => count + (error.code === code ? 1 : 0), 0);
